var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinningBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 -9.61651e-07C4.92487 -1.49276e-06 1.49276e-06 4.92487 9.61651e-07 11C4.30546e-07 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 -4.30546e-07 11 -9.61651e-07Z",
    fill: "#0072C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4216 11.5322L18.1286 10.8252L17.1091 9.8057L12.3229 5.0195L11.3034 4L10.5964 4.707L11.6161 5.7267L8.92449 8.4189L8.34339 7.8379C8.19589 7.6904 7.80629 7.2979 7.27699 7.5576L4.66769 8.8457C4.29849 9.0205 4.07489 9.4346 4.01729 9.7666C3.96069 10.0908 4.04459 10.3916 4.24679 10.5937L7.62309 13.97C7.48749 14.1237 4.44889 17.5669 4.44889 17.5669C4.28279 17.746 4.55239 18.015 4.73169 17.8498L8.32859 14.6755L11.7058 18.0527C11.8796 18.2265 12.114 18.3193 12.3699 18.3193C12.4402 18.3193 12.5115 18.3125 12.5847 18.2978C12.9519 18.2255 13.2644 17.9824 13.3982 17.6611L14.5994 14.7841C14.7957 14.287 14.4226 13.9159 14.2644 13.7587L13.7107 13.204L16.4021 10.5126L17.4216 11.5322ZM12.2966 13.2041L13.5583 14.4668C13.572 14.4805 13.5983 14.5059 13.6218 14.5313L12.4792 17.2696C12.4646 17.2901 12.4187 17.3135 12.3854 17.3184L4.99969 9.9678C4.99479 9.9101 5.05629 9.7793 5.10319 9.7461L7.60319 8.5117C7.61299 8.5215 7.62369 8.5322 7.63639 8.5449L8.92449 9.833L12.3229 6.4336L15.695 9.8057L12.2966 13.2041Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinningBlueIcon);
export default __webpack_public_path__ + "static/media/Pinning_blue_icon.e8e17b98bb563319b1147507c5f697c1.svg";
export { ForwardRef as ReactComponent };